import { render, staticRenderFns } from "./mainvote.vue?vue&type=template&id=80ba7d5c&scoped=true&"
import script from "./mainvote.vue?vue&type=script&lang=js&"
export * from "./mainvote.vue?vue&type=script&lang=js&"
import style0 from "./mainvote.vue?vue&type=style&index=0&id=80ba7d5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80ba7d5c",
  null
  
)

export default component.exports